import { DataTable } from "@/components/data-table";
import { Form, useForm } from "@/components/form";
import { useGetAllDepartamentosQuery } from "../api/get-all-departamentos";
import { formatString } from "@/shared/formats";
import { Departamento } from "@/shared/types/departamentos";
import { IconButton, Stack, StackProps } from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import { useFilters } from "@/components/filters";

interface DepartamentoSearchProps extends StackProps {
    onDepartamentoSelect?: (departamento: Departamento) => void
}

export default function DepartamentoManualSearch({
    onDepartamentoSelect,
    ...props
}: DepartamentoSearchProps) {
    const filterData = useFilters({
        useURL: false,
        filters: [
            { type: "string", label: "Nombre", name: "nombre" },
            { type: "string", label: "Código", name: "codigo" },
            { type: "pagination" }
        ]
    })

    const queryResult = useGetAllDepartamentosQuery(filterData.filterData);

    const filterForm = useForm({
        defaultValues: filterData.filterData,
        onSubmit: ({ value }) => filterData.setFilterData(value),
        closeModalOnSubmit: false,
        submitOnce: false,
    })

    return <Stack minHeight={"70vh"} gap={3} {...props}>
        <Form form={filterForm} direction={"row"} flexWrap={"wrap"} gap={2}>
            <Form.TextField name="nombre" label="Nombre" size="small" />
            <Form.TextField name="codigo" label="Código" size="small" />
            <Form.SubmitButton>Filtrar</Form.SubmitButton>
        </Form>
        <DataTable flex={1}>
            <DataTable.Content
                fit="flex"
                rows={queryResult.data?.result}
                loading={queryResult.isFetching}
                columns={[
                    { key: "codigo", header: "Código", render: row => formatString(row.codigo) },
                    { key: "nombre", header: "Nombre", render: row => formatString(row.nombre) },
                    {
                        header: "", align: "center", width: "auto",
                        render: departamento => <IconButton onClick={() => onDepartamentoSelect && onDepartamentoSelect(departamento)}>
                            <AddIcon />
                        </IconButton>
                    }
                ]}
            />
            <DataTable.Pagination queryResult={queryResult} filterData={filterData} />
        </DataTable>
    </Stack>
}
